import { LOGIN_USER, REGISTER_USER } from '../constants/users';

const initialState = {
  username: '',
  email: '',
  password: ''
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER:
      return {
        ...state,
        username: action.payload.data.username,
        email: action.payload.data.email,
        password: action.payload.data.password
      };

    case LOGIN_USER:
      return {
        ...state,
        username: action.payload.username,
        email: action.payload.email,
        password: action.payload.password
      };

    default:
      return state;
  }
};
